import React, { useState } from "react";
import NewSubjectButton from "../OpenButton/OpenButton";
import NewSubjectContainer from "../NewSubjectContainer";

type ShowSubjectButtonProps = {
    show: boolean;
};

function NewSubjectButtonContainer({ show }: ShowSubjectButtonProps) {
    const [isOpen, setModalOpen] = useState(false);

    if (show) {
        return (
            <NewSubjectButton setModalOpen={setModalOpen} modalIsOpen={isOpen} look="button">
                <NewSubjectContainer setModalOpen={setModalOpen}  />
            </NewSubjectButton>
        );
    }
    return <span></span>;
}

export {
    NewSubjectButtonContainer
}